/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ServiceAmountTable.vue?vue&type=template&id=66f05131&scoped=true&lang=html&"
import script from "./ServiceAmountTable.vue?vue&type=script&lang=js&"
export * from "./ServiceAmountTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAmountTable.vue?vue&type=style&index=0&id=66f05131&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f05131",
  null
  
)

export default component.exports